<template>
  <div>
    <breadcrumb-bar :crumbs="[{name: 'Calendar'}]"></breadcrumb-bar>
    <!-- END PAGE HEADER-->
    <div class="col-md-12">
      <div class="row">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption caption-md">
              <i class="icon-globe theme-font hide"></i>
              <span class="caption-subject bold uppercase">Calendar</span>
            </div>
          </div>
          <div class="portlet-body">
            <transition name="fade">
              <calendar-crud type="calendar"></calendar-crud>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import CalendarCRUD from '../components/widgets/CalendarCRUD.vue';
  import Breadcrumbs from '@/components/Breadcrumbs';
  import {HTTP} from '@/http-common';
  import auth from '@/auth'
  import {mapActions} from 'vuex';
  export default {
    name: 'admin-app',
    components: {
      'breadcrumb-bar': Breadcrumbs,
      'calendar-crud': CalendarCRUD
    }
  }
</script>



// WEBPACK FOOTER //
// Calendar.vue?f3502838